import Section from '@app/components/atoms/Section/Section'
import useRemember from '@app/libs/useRemember'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const CustomIconButton = styled(IconButton)((props) => {
  const { theme } = props
  if (props['aria-expanded']) {
    return {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    }
  }

  return {
    transform: 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }
})

const VoucherRequestedDetail = ({ vouchersRequested }) => {
  const { t } = useTranslation()

  const [allExpandedVoucher, setAllExpandedVoucher] = useRemember(`VoucherDetail:${vouchersRequested.id}`, {
    description: true,
    guide: true,
    condition: true,
  })

  const handleExpand = (attribute) => {
    setAllExpandedVoucher({ ...allExpandedVoucher, [attribute]: !allExpandedVoucher[attribute] })
  }

  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.DESCRIPTION')}{' '}
                <CustomIconButton
                  aria-expanded={allExpandedVoucher.description}
                  aria-label="show more"
                  onClick={() => handleExpand('description')}
                >
                  <ExpandMore />
                </CustomIconButton>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.description} timeout="auto">
                {vouchersRequested.description ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: vouchersRequested.description }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.HOW_TO_USE')}{' '}
                <CustomIconButton
                  aria-expanded={allExpandedVoucher.guide}
                  aria-label="show more"
                  onClick={() => handleExpand('guide')}
                >
                  <ExpandMore />
                </CustomIconButton>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.guide} timeout="auto">
                {vouchersRequested.how_to_use ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: vouchersRequested.how_to_use }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.TERM_AND_CONDITION')}{' '}
                <CustomIconButton
                  aria-expanded={allExpandedVoucher.condition}
                  aria-label="show more"
                  onClick={() => handleExpand('condition')}
                >
                  <ExpandMore />
                </CustomIconButton>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.condition} timeout="auto">
                {vouchersRequested.condition ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: vouchersRequested.condition }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}

export default VoucherRequestedDetail
